import React, { useState, useRef, useEffect, useContext } from 'react'
import PrimaryButton from '../../../../product/components/atoms/PrimaryButton'
import { useHistory } from 'react-router-dom'
import {
    handleRedirectInternal,
    dateTimeFormatFunction,
    currencyFormat,
} from '../../../../custom/common/components'
import './InvoiceCard.css'

const InvoiceCard = (props) => {
    const [product, setProduct] = useState()
    const history = useHistory()
    useEffect(() => {
        setProduct(props.data)
    }, [props.data])
    return (
        <>
            <div className="invoiceCard">
                {product ? (
                    <>
                        <h3 className="custName">Invoice #{product.common_invoice}</h3>
                        <h5>{dateTimeFormatFunction(product.paiddate)}</h5>
                        <div className="icItems d-flex justify-content-between align-items-center">
                            <span>Total items:</span> <span>{product.total_items}</span>
                        </div>
                        <div className="icPaid d-flex justify-content-between align-items-center">
                            <span>Amount:</span>{' '}
                            <span>{currencyFormat(product.total_invoice)}</span>
                        </div>
                        {product.partial === 1 ? (
                            <>
                                <PrimaryButton
                                    label="Pay invoice"
                                    onClick={() =>
                                        handleRedirectInternal(
                                            history,
                                            `checkout/invoice/${product.common_invoice}`,
                                        )
                                    }
                                    btnSize="small"
                                />
                                <PrimaryButton
                                    label="View invoice"
                                    onClick={() =>
                                        handleRedirectInternal(
                                            history,
                                            `invoice/${product.common_invoice}`,
                                        )
                                    }
                                    btnSize="small"
                                />
                            </>
                        ) : (
                            <PrimaryButton
                                label="View invoice"
                                onClick={() =>
                                    handleRedirectInternal(
                                        history,
                                        `invoice/${product.common_invoice}`,
                                    )
                                }
                                btnSize="small"
                            />
                        )}
                    </>
                ) : null}
            </div>
        </>
    )
}

export default InvoiceCard
